import { render, staticRenderFns } from "./OreStatusTimeLine.vue?vue&type=template&id=a36b3246&scoped=true"
import script from "./OreStatusTimeLine.vue?vue&type=script&lang=js"
export * from "./OreStatusTimeLine.vue?vue&type=script&lang=js"
import style0 from "./OreStatusTimeLine.vue?vue&type=style&index=0&id=a36b3246&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36b3246",
  null
  
)

export default component.exports